import { render, staticRenderFns } from "./resourceDialog.vue?vue&type=template&id=f61dc794&scoped=true"
import script from "./resourceDialog.vue?vue&type=script&lang=js"
export * from "./resourceDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceDialog.vue?vue&type=style&index=0&id=f61dc794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61dc794",
  null
  
)

export default component.exports